import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

type ComponentProps<T = null> = { [key: string]: any };
export interface BllModalOptions extends NgbModalOptions {
	componentProps?: ComponentProps;
}

@Injectable({
	providedIn: 'root',
})
export class BllModal {
	constructor(private modalService: NgbModal) {}

	async open(content: any, options?: BllModalOptions) {
		// TODO: object assing (if more options wil lbe added)
		options.centered = options.centered ?? false;
		options.animation = options.animation ?? true;
		options.backdrop = options.backdrop || 'static';
		options.keyboard = options.keyboard ?? true;
		const modalRef = this.modalService.open(content, options);
		if (modalRef.componentInstance && options.componentProps) {
			for (const key in options.componentProps) {
				modalRef.componentInstance[key] = options.componentProps[key];
			}
		}
		let data = null;
		try {
			data = await modalRef.result;
		} catch (err) {}

		return {
			modal: modalRef,
			data,
		};
	}
}
